const styles = (theme) => {
    return {
        spiros: {
            width: 600,
        },

        spiros__icon: {
            color: theme.palette.text.secondary,
        },
    };
};

export default styles;
